export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7791.80a08b58.jpg";